import 'antd/dist/reset.css';
import '../../tailwind.css';
import '../global.less';

import { rootContainer } from '@/app';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './routes';

const basename = (import.meta.env.BASE_URL || '/').replace(/\/$/, '') || '/';
if (
  process.env.NATIVE_API_URL &&
  !/^\/(m(?:\/|$)|login(?:\/|$))/.test(location.pathname)
) {
  history.replaceState(null, '', '/m/customers');
}
const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element #root was not found.');
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    {rootContainer(
      <BrowserRouter basename={basename}>
        <AppRoutes />
      </BrowserRouter>,
    )}
  </React.StrictMode>,
);
